import device from 'managers/device';

export module RecordingHelpers {
    export const checkIfVideoRecordingIsSupported = system.lazyAsync(async () => {
        try {
            if (window.MediaRecorder != undefined) {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true }); //get stream
                stream.getTracks().forEach(track => track.stop()); //dispose stream

                return true;
            }

            return false;
        } catch {
            return false;
        }
    });

    export const checkIfAudioRecordingIsSupported = system.lazyAsync(async () => {
        try {
            if (window.MediaRecorder != undefined) {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true }); //get stream
                stream.getTracks().forEach(track => track.stop()); //dispose stream

                return true;
            }

            return false;
        } catch {
            return false;
        }
    });

    const checkIfScreenRecordingSupportedInternal = system.lazy(() => {
        const browser = bowser.getParser(window.navigator.userAgent);
        const isSafari = browser.satisfies({ safari: '>=1' }) ?? false;

        if (isSafari)
            return false;

        if ("mediaDevices" in navigator && "getDisplayMedia" in navigator.mediaDevices) {
            if ("getUserMedia" in navigator || "mediaDevices" in navigator && "getUserMedia" in (<any>navigator).mediaDevices) {
                if (typeof MediaRecorder === "function")
                    return "readyState" in MediaStreamTrack.prototype
            }
        }
    });

    export const checkIfScreenRecordingSupported = ko.pureComputed(() => !device.isMobile() && checkIfScreenRecordingSupportedInternal());
}